import { render, staticRenderFns } from "./BaseOutlineButton.vue?vue&type=template&id=aba07fb2&scoped=true"
import script from "./BaseOutlineButton.vue?vue&type=script&lang=js"
export * from "./BaseOutlineButton.vue?vue&type=script&lang=js"
import style0 from "./BaseOutlineButton.vue?vue&type=style&index=0&id=aba07fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba07fb2",
  null
  
)

export default component.exports